export const DAYS_AFTER_HANDOVER = 'days_after_handover'
export const AFTER_ADVANCE_SETTLEMENT = 'after_advance_settlement'
export const OTHER = 'other'

export const ALL_LEASE_DEPOSIT_RETURN_TYPES = [
  DAYS_AFTER_HANDOVER,
  AFTER_ADVANCE_SETTLEMENT,
  OTHER,
] as const

export type LeaseDepositReturnType =
  (typeof ALL_LEASE_DEPOSIT_RETURN_TYPES)[number]
